export default "__VITE_PUBLIC_ASSET__de938836__"